import axios from "axios";
import { apiUrl } from "./Constants";

const authHeaders = () => {
  return {
    "access-token": localStorage.getItem("access_token"),
    client: localStorage.getItem("client"),
    uid: localStorage.getItem("uid"),
  };
};

const handleResponseError = (error) => {
  if (error.response?.status === 401) {
    return {
      success: false,
      status: 401,
      message: "Unauthorized access",
    };
  }
  return responseCatch(error);
};

const responseThen = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return { success: true, data: response.data };
  } else {
    return {
      success: false,
      status: response.status,
      message: response.data.message,
    };
  }
};

const responseCatch = (error) => {
  if (error.response) {
    return {
      success: false,
      status: error.response?.status,
      message: error.response.data.message,
    };
  } else {
    return {
      success: false,
      status: 500,
      message: "something went wrong",
    };
  }
};
export const apiJson = {
  orders: {
    getOrders: function getOrders(page, remainingParams) {
      return axios
        .get(
          apiUrl.orders.getOrders +
            page +
            "&records_per_page=10" +
            remainingParams,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getTabsCount: function getTabsCount() {
      return axios
        .get(apiUrl.orders.getTabsCount, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getOrderDetail: function getOrderDetail(id) {
      return axios
        .get(apiUrl.orders.getOrderDetail + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateOrderStatus: function updateOrderStatus(id, body) {
      return axios
        .put(apiUrl.orders.updateOrderStatus + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    generateOrderReceipt: function generateOrderReceipt(id) {
      return axios
        .get(apiUrl.orders.generateOrderReceipt + id + "/receipt", {
          headers: authHeaders(),
          responseType: "blob",
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    serchByCustomerId: function serchByCustomerId(id) {
      return axios
        .get(apiUrl.orders.serchByCustomerId + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    generatePackingSlip: function generatePackingSlip(id) {
      return axios
        .get(apiUrl.orders.getPackingSlip + id + "/packing_slip", {
          headers: authHeaders(),
          responseType: "blob",
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  shipmentRules: {
    getShipmentRules: function getShipmentRules() {
      return axios
        .get(apiUrl.shipmentRules.getShipmentRules, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  categories: {
    getCategories: function getCategories() {
      return axios
        .get(apiUrl.categories.getCategories, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getCategorieForProductServices: function getCategorieForProductServices() {
      return axios
        .get(apiUrl.categories.getCategoriesForProductsServices, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  imports: {
    bulkImport: function bulkImport(body) {
      return axios
        .post(apiUrl.imports.bulkImport, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  brands: {
    getBrands: function getBrands() {
      return axios
        .get(apiUrl.brands.getBrands, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getBrandsByCategory: function getBrandsByCategory(category_id) {
      return axios
        .get(apiUrl.brands.getBrandByCategory + category_id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  coupons: {
    getCoupons: function getCoupons(page) {
      return axios
        .get(apiUrl.coupons.getCoupons + page + "&records_per_page=10", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    createCoupon: function createCoupon(body) {
      return axios
        .post(apiUrl.coupons.createCoupon, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    updateCoupon: function updateCoupon(id, body) {
      return axios
        .put(apiUrl.coupons.updateCoupon + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
  },

  services: {
    getServices: function getServices(page, remainingParams) {
      return axios
        .get(
          apiUrl.services.getServices +
            page +
            "&records_per_page=10" +
            remainingParams,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getTabsCount: function getTabsCount() {
      return axios
        .get(apiUrl.services.getTabsCount, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getServiceDetail: function getServiceDetail(id) {
      return axios
        .get(apiUrl.services.getServiceDetail + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    createService: function createService(body) {
      return axios
        .post(apiUrl.services.createService, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    updateService: function updateService(id, body) {
      return axios
        .put(apiUrl.services.updateService + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    deleteService: function deleteService(id) {
      return axios
        .delete(apiUrl.services.deleteService + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },

    getRelatedServices: function getRelatedServices() {
      return axios
        .get(apiUrl.services.getRelatedServices, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
  },

  products: {
    getProducts: function getProducts(page, remainingParams) {
      return axios
        .get(
          apiUrl.products.getProducts +
            page +
            "&records_per_page=10" +
            remainingParams,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getTabsCount: function getTabsCount() {
      return axios
        .get(apiUrl.products.getTabsCount, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    getProductDetail: function getProductDetail(id) {
      return axios
        .get(apiUrl.products.getProductDetail + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    createProduct: function createProduct(body) {
      return axios
        .post(apiUrl.products.createProduct, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateProduct: function updateProduct(id, body) {
      return axios
        .put(apiUrl.products.updateProduct + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    deleteProduct: function deleteProduct(id) {
      return axios
        .delete(apiUrl.products.deleteProduct + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    getRelatedProducts: function getRelatedProducts(q) {
      return axios
        .get(apiUrl.products.getRelatedProducts + `?q=${q}`, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    getRelatedTools: function getRelatedTools(q) {
      return axios
        .get(apiUrl.products.getRelatedTools + `?q=${q}`, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
  },

  export: {
    exportProducts: function exportProducts() {
      return axios
        .get(apiUrl.export.exportProducts, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  variants: {
    getVariants: function getVariants(id) {
      return axios
        .get(apiUrl.variants.getVariants + id + "/variants", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getVariantDetail: function getVariantDetail(product_id, variant_id) {
      return axios
        .get(
          apiUrl.variants.getVariantDetail +
            product_id +
            "/variants/" +
            variant_id,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    createVariant: function createVariant(id, body) {
      return axios
        .post(apiUrl.variants.createVariant + id + "/variants/", body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    updateVariant: function updateVariant(product_id, variant_id, body) {
      return axios
        .put(
          apiUrl.variants.updateVariant +
            product_id +
            "/variants/" +
            variant_id,
          body,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },

    deleteVariant: function deleteVariant(id, vid) {
      return axios
        .delete(apiUrl.variants.deleteVariant + id + "/variants/" + vid, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
  },

  returns: {
    getReturns: function getReturns(page) {
      return axios
        .get(apiUrl.returns.getReturns + page + "&records_per_page=10", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getReturnDetail: function getReturnDetail(id) {
      return axios
        .get(apiUrl.returns.getReturnDetail + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateReturnStatus: function updateReturnStatus(id, body) {
      return axios
        .put(apiUrl.returns.updateReturnStatus + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
  },

  profile: {
    getUsers: function getUsers(page) {
      return axios
        .get(apiUrl.profile.getUsers + page + "&records_per_page=12", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  vendorProfile: {
    getVendor: function getVendorProfile() {
      return axios
        .get(apiUrl.vendorProfile.getVendor, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getVendorProfile: function getVendorProfile() {
      return axios
        .get(apiUrl.vendorProfile.getVendorProfile, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    changePassword: function changePassword(body) {
      return axios
        .patch(apiUrl.vendorProfile.changePassword, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  createStore: {
    createStore: function createStore(body) {
      return axios
        .post(apiUrl.createStore.createStore + "/create_store", body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateStoreDocuments: function updateStoreDocuments(body) {
      return axios
        .patch(apiUrl.createStore.updateStore + "/update_documents", body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateStoreBank: function updateStoreBank(body) {
      return axios
        .patch(apiUrl.createStore.updateStore + "/update_bank_details", body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateStoreVat: function updateStoreVat(body) {
      return axios
        .patch(apiUrl.createStore.updateStore + "/update_vat", body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateStoreTermsConditions: function updateStoreTermsConditions(body) {
      return axios
        .patch(
          apiUrl.createStore.updateStore + "/update_terms_conditions",
          body,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateStore: function updateStore(body) {
      return axios
        .patch(apiUrl.createStore.updateStore, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    validateName: function validateName(names) {
      return axios
        .get(
          apiUrl.createStore.validateName +
            names.store_name_en +
            "&store_name_ar=" +
            names.store_name_ar,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  disputes: {
    getDisputes: function getDisputes(page) {
      return axios
        .get(apiUrl.disputes.getDisputes + page + "&records_per_page=10", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getDisputeDetail: function getDisputeDetail(id) {
      return axios
        .get(apiUrl.disputes.getDisputeDetail + id + "?role=vendor", {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    createReply: function createReply(id, body) {
      return axios
        .post(
          apiUrl.disputes.createReply + id + "/dispute_replies?role=vendor",
          body,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    createDispute: function createDispute(body) {
      return axios
        .post(apiUrl.disputes.createDispute, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  reports: {
    getTotalSales: function getTotalSales(start_date, end_date) {
      return axios
        .get(
          apiUrl.reports.getTotalSales +
            start_date +
            "&sale[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getOutofStockProducts: function getOutofStockProducts() {
      return axios
        .get(apiUrl.reports.getOutofStockProducts, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getRecentOrders: function getRecentOrders(start_date, end_date) {
      return axios
        .get(
          apiUrl.reports.getRecentOrders +
            start_date +
            "&order[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getOrderTobeDelivered: function getOrderTobeDelivered(
      start_date,
      end_date,
    ) {
      return axios
        .get(
          apiUrl.reports.getOrderTobeDelivered +
            start_date +
            "&order[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getInventory: function getInventory() {
      return axios
        .get(apiUrl.reports.getInventory, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    getTopProductsSold: function getTopProductsSold(
      limit,
      start_date,
      end_date,
    ) {
      return axios
        .get(
          apiUrl.reports.getTopProductsSold +
            +limit +
            "&sale[start_date]=" +
            start_date +
            "&sale[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    getAverageOrderValue: function getAverageOrderValue(start_date, end_date) {
      return axios
        .get(
          apiUrl.reports.getAverageOrderValue +
            start_date +
            "&order[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    getEarningAndCommissionPerOrder: function getEarningAndCommissionPerOrder(
      start_date,
      end_date,
    ) {
      return axios
        .get(
          apiUrl.reports.getEarningAndCommissionPerOrder +
            start_date +
            "&earning[end_date]=" +
            end_date,
          {
            headers: authHeaders(),
          },
        )
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    getPlatformSettingID: function getPlatformSettingID() {
      return axios
        .get(apiUrl.reports.getPlatformSettingID, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getPlatformSetting: function getPlatformSetting(id) {
      return axios
        .get(apiUrl.reports.getPlatformSetting + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  emails: {
    sendEmail: function sendEmail(body) {
      return axios
        .post(apiUrl.emails.sendEmail, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },
  dashboard: {
    getDashboardData: function getDashboardData() {
      return axios
        .get(apiUrl.dashboard.getDashboardData, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  banner: {
    createBanner: function createBanner(body) {
      return axios
        .post(apiUrl.banner.createBanner, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    updateBanner: function updateBanner(id, body) {
      return axios
        .put(apiUrl.banner.updateBanner + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    getBanners: function getBanners() {
      return axios
        .get(apiUrl.banner.getBanner, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getBanner: function getBanner(id) {
      return axios
        .get(apiUrl.banner.getBanner + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    deleteBanner: function deleteBanner(id) {
      return axios
        .delete(apiUrl.banner.deleteBanner + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getBannerDetails: function getBannerDetails(id) {
      return axios
        .get(apiUrl.banner.getBannerDetails + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  shop_banner: {
    createBanner: function createBanner(body) {
      return axios
        .post(apiUrl.shop_banner.createBanner, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    updateBanner: function updateBanner(id, body) {
      return axios
        .put(apiUrl.shop_banner.updateBanner + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }
          return responseCatch(error);
        });
    },
    getBanners: function getBanners() {
      return axios
        .get(apiUrl.shop_banner.getBanner, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getBanner: function getBanner(id) {
      return axios
        .get(apiUrl.shop_banner.getBanner + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    deleteBanner: function deleteBanner(id) {
      return axios
        .delete(apiUrl.shop_banner.deleteBanner + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getBannerDetails: function getBannerDetails(id) {
      return axios
        .get(apiUrl.shop_banner.getBannerDetails + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  store: {
    getMenu: function getMenu() {
      return axios
        .get(apiUrl.store.getMenuItems, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    getMenuItem: function getMenuItem(id) {
      return axios
        .get(apiUrl.store.getMenuItems + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    addMenuItem: function addMenuItem(body) {
      return axios
        .post(apiUrl.store.addMenuItem, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    editMenuItem: function editMenuItem(id, body) {
      return axios
        .patch(apiUrl.store.addMenuItem + "/" + id, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    deleteMenuItem: function deleteMenuItem(id) {
      return axios
        .delete(apiUrl.store.getMenuItems + "/" + id, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },

  auth: {
    signout: function signout() {
      return axios
        .delete(apiUrl.auth.signout, {
          headers: {
            "access-token": localStorage.getItem("access_token"),
            client: localStorage.getItem("client"),
            uid: localStorage.getItem("uid"),
          },
        })
        .then((response) => {
          return { success: true, response };
        })
        .catch((error) => {
          return { success: false, error: error };
        });
    },
    resetPassEmail: function resetPass(body) {
      return axios
        .post(apiUrl.auth.resetPass, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          } else if (error.response?.data?.success === false) {
            return {
              success: false,
              status: 410,
              message: error.response.data.errors[0],
            };
          } else {
            return responseCatch(error);
          }
        });
    },

    validateToken: function validateToken() {
      return axios
        .get(apiUrl.auth.validateToken, {
          headers: authHeaders(),
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return {
              success: true,
              data: response.data,
              headers: response.headers,
            };
          } else {
            return {
              success: false,
              status: response.status,
              message: response.data.message,
            };
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            return {
              success: false,
              status: 401,
              message: "Unauthorized access",
            };
          }

          return responseCatch(error);
        });
    },
  },

  onboarding: {
    createStore: function createStore(body) {
      return axios
        .post(apiUrl.onboarding.createStore, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
    updateBusinessDetails: function updateBusinessDetails(body) {
      return axios
        .patch(apiUrl.onboarding.updateBusinessDetails, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    updateBankDetails: function updateBankDetails(body) {
      return axios
        .patch(apiUrl.onboarding.updateBankDetails, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },

    updateTermsConditions: function updateTermsConditions(body) {
      return axios
        .patch(apiUrl.onboarding.updateTermsConditions, body, {
          headers: authHeaders(),
        })
        .then((response) => {
          return responseThen(response);
        })
        .catch((error) => {
          return handleResponseError(error);
        });
    },
  },
};
